export default __webpack_public_path__ + "static/media/th-flag.2c2bd871.svg";